var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo40AnosMdsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 696.8 423.8",
    style: {
      enableBackground: "new 0 0 696.8 423.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.1,159.7h4.3l17.3,39.1h-4.8l-4.7-10.5h-20l-4.6,10.5h-4.7L451.1,159.7z M461.7,184.4l-8.5-19l-8.5,19 H461.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.4,160h3.9l24.1,31.1V160h4.4v38.9h-3.8l-24.1-31.2v31.2h-4.4V160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.9,179.4c0,11.4-8.4,20.1-19.7,20.1c-11.2,0-19.6-8.7-19.6-20.1s8.4-20.1,19.6-20.1 C557.5,159.3,565.9,168,565.9,179.4z M561.3,179.4c0-9.1-6.6-15.9-15.1-15.9c-8.4,0-15,6.8-15,15.9c0,9.1,6.6,15.9,15,15.9 C554.7,195.3,561.3,188.5,561.3,179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M575.1,195.4v-5c2.7,2.4,8.3,4.9,14.2,4.9c5.7,0,10.2-2.6,10.2-7c0-4.7-4.4-6.1-10.7-7.8 c-7.1-2-12.9-3.9-12.9-11c0-5.8,4.9-10.2,13.6-10.2c4.9,0,9.1,1.3,12.2,3.2v4.6c-3.2-2-7.4-3.6-12.1-3.6c-6.5,0-9.1,2.9-9.1,6.1 c0,4.5,5.2,5.4,10.8,7.1c6.3,1.9,12.9,4.2,12.9,11.6c0,7.3-6.7,11.3-14.6,11.3C583.6,199.5,578.3,197.7,575.1,195.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.8,219h-22.8v32.6c0,2.7,2.2,4.9,4.9,4.9h9.8V232h7c11.1,0,17.5,5.7,17.5,15.7 c0,10-6.4,15.7-17.5,15.7h-7v0h-9.9c-2.7,0-4.9,2.2-4.9,4.8v8.1h22.8c18.7,0,31.7-11.8,31.7-28.6 C555.5,230.8,542.5,219,523.8,219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434,219h14.7l14.5,22l14.6-22h14.6v57.3h-9.8c-2.7,0-4.8-2.2-4.8-4.8v-30.1l-10.2,15.4h-8.1l-10.6-15.4 v34.9H434V219z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M559.5,271.3v-6.4c0-3.5,3.7-5.8,6.9-4.3c4.6,2.1,10.1,3.5,14.7,3.5c4.2,0,8.8-1,8.8-4.5 c0-3.7-4.3-4.3-11.1-6.4c-9.6-2.9-19.3-5.9-19.3-18.2c0-11.3,9.1-17.2,22.5-17.2c8.2,0,14.7,2.3,19.4,4.7v14.2 c-4.7-2.9-12.4-5.6-19.2-5.6c-5.6,0-7.5,1.5-7.5,3.8c0,2.9,5.3,3.4,12.9,5.8c9.3,3,17.6,7.4,17.6,18.2 c0,11.5-9.9,18.4-23.4,18.4C573.6,277.4,565.8,275.6,559.5,271.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "192.4,276.3 192.5,301.1 219,301 218.9,276.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.4,139c-44.8,0-81,36.3-81,81c0,5.4,0.5,10.7,1.6,15.8l-16,0V122.7h-25.5L91.7,244.3l8.8,19.7h92.1h26.6 h28.2l0,0c14.4,22.3,39.5,37.1,68.1,37.1c44.8,0,81-36.3,81-81S360.1,139,315.4,139z M192.6,235.8h-63.4l63.4-74.1V235.8z  M315.4,275.7c-30.7,0-55.7-24.9-55.7-55.7s24.9-55.7,55.7-55.7S371,189.3,371,220S346.1,275.7,315.4,275.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo40AnosMdsWhite);
export default __webpack_public_path__ + "static/media/logo_40_anos_mds_white.c1e177991dcd8b24f12b64c8104a6d69.svg";
export { ForwardRef as ReactComponent };